import type { FaireProductEntity } from "../../entity_types/product";

export const p_2rr5rz6h27: FaireProductEntity = {
  token: "p_2rr5rz6h27",
  type: "product",
  name: "Plush Vetiver– HI-FI Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/25c1e727e977b1efb5645357c5e5c2aba658c0dd2b9aa76864b0736d697fde46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a3403f9ae9bcfd35ed197a0d0837beda3ca027a00f42e878ac775d0a6c21cf8.jpeg",
    "https://cdn.faire.com/fastly/e4ef77169b9dcd818f35b3fc8a0198635d0be7b4ffbae33e16e77f6885694189.jpeg",
    "https://cdn.faire.com/fastly/84a93be46a2a4389f12e7f7960caa60f8619a96d48057472c87091d2d102e326.jpeg",
    "https://cdn.faire.com/fastly/85a2ee4fefe9ba3c79c5869600844b38daccbbef78d96ffb30a12842cdc3bb77.jpeg",
    "https://cdn.faire.com/fastly/0bbdc137fd1da852c6fa7b1984f0686ab4e636a6176daab6d362a28d6264b7d6.jpeg",
  ],
  priceDollars: 9.5,
  description:
    '*RESTOCKING IN SUMMER 2026*\n\n\nInspired by low-lit listening bars and ultra-chic hotel lounges, HI-FI is an olfactive expression of transportive sensory experiences and a meticulous attention to quality and atmosphere.\n\nPlush velvet and smooth banquettes in a dimly lit cocktail lounge. Musky, earthy, and soft with a velvety floral undertone.  Haitian vetiver, velvet iris, patchouli leaf, and beetroot.\n\nIncense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach vermilion-hued charcoal-based Incense stick is hand-dipped in California using fine fragrance oils.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours.\n\n20 sticks within a plastic sleeve and packaged into a premium drawer style box.  Each stick is approximately 7" long.',
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:01.396Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
